<div class="flex flex-col md:m-0 rounded-ace-mode" [ngClass]="[
        image && image?.url ? ' shadow-card card-border h-full ' + backgroundColor : 'self-center',
        isDarkBackgroundColor && !image?.url ? backgroundColor : ''
     ]" (click)="ctaClick()">
  @if (image && image.url) {
    <div class="w-full career-center-image h-48">
      <img
        src="{{ imgixService.buildImgixUrl(image.url) }}"
        [alt]="image.altText ? image.altText : ''"
        width="800"
        height="500"
        class="h-48 object-cover career-center-image rounded-t-md"
        />
    </div>
  }
  <div class="content-card max-w-[800px] w-full top-3/4 z-10 rounded h-full py-v-spacing" [ngClass]="{'px-v-spacing': cardLocation === 'center' || image || isDarkBackgroundColor, 'p-v-spacing': cardLocation === 'start' && !image,'pl-v-spacing': cardLocation === 'end' && !image}">
    @if (textContent) {
      <div class="mx-auto flex flex-col justify-between h-full">
        <div class="wysiwyg" [class.mb-v-spacing]="ctaLabel && ctaLink" [innerHTML]="textContent"></div>
        <div class="mt-auto">
          @if (ctaLabel && ctaLink && textContent) {
            <vision-button defaultStyle="tertiary" [data]="buttonData"></vision-button>
          }
        </div>
      </div>
    }
  </div>
</div>
